import IPOItemComponent from "../../components/IPOItemComponent";
import { Col, Row } from "react-bootstrap";
import * as querySelectors from "../../../../selectors/query";
import _ from "lodash";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import IPOListTableComponent from "../../components/IPOListTableComponent";

function UpcomingTab({data}) {
  const isLoading = querySelectors.getQueryIsLoading(data);
  const { data: ipoData } = querySelectors.getQueryData(data);
  return (
    <div className="pb-4">
      <IPOListTableComponent loading={isLoading} data={ipoData} closeSelect></IPOListTableComponent>
    </div>
  );
}
export default UpcomingTab;
